module.exports = __webpack_public_path__ + "assets/img/iframe_img2.885843fa.png";